function filterCitiesResponse(cities, collectionId) {
  if (!cities) {
    return;
  }
  const citiesResult = [];
  cities.flat(1).forEach((city) => {
    if (city.collection_id !== collectionId) {
      return;
    }
    if (!citiesResult.some((c) => c.id === city.id)) {
      citiesResult.push(city);
    }
  });
  return citiesResult;
}
export {
  filterCitiesResponse
};
